

const routes = [
  //编辑快速制作
  {
    path: '/partJob/createCourse',
    name: 'partJob/createCourse',
    meta: {
      title: '编辑课本'
    },
    component: () => import('../pages/textbook/createCourse/index.vue'),
  },
  //编辑视频配音
  {
    path: '/partJob/createVideoDubbing',
    name: 'partJob/createVideoDubbing',
    meta: {
      title: '编辑视频配音'
    },
    component: () => import('../pages/createVideoDubbing/editBook.vue'),
  },
  //编辑乐谱
  {
    path: '/partJob/createMusic',
    name: 'partJob/createMusic',
    meta: {
      title: '编辑乐谱'
    },
    component: () => import('../pages/createMusic/index.vue'),
  },
]

export default routes
